<script lang="ts">
    import {
        mobileView,
        focusDetected,
        scrollBarWidth,
        scrollDisabled,
        activeColor,
        colors,
        activeSection,
        keyboardMode,
        menuDrawerOpen,
        tabDetected,
        header_menu_height,
        header_hiding,
    } from "$lib/data";
    import { randomIntFromInterval } from "$lib/utilities";
    import Desktop from "$lib/components/layout/header/navigation/Desktop.svelte";
    import MobileTrigger from "$lib/components/layout/header/navigation/MobileTrigger.svelte";
    import Logo from "$lib/components/layout/header/Logo.svelte";
    import { browser } from "$app/environment";

    let browserWidth: number = 1050;
    let yScroll: number = 0;
    let shadow: boolean = false;
    let breakPoint: number = 1024;

    // slow shrink header
    $: if (browserWidth > breakPoint && browser) {
        if (yScroll === 0) {
            $header_menu_height = 100;
        } else if (yScroll < 400) {
            $header_menu_height = Math.min(Math.max(100 - yScroll * 0.2, 60), 100);
            // if (dev) console.log(Math.min(Math.max(100 - yScroll * 0.2, 60), 100));
        } else if (yScroll > 400) {
            // sets the header $header_menu_height if the page loads at a scrolled position
            $header_menu_height = 60;
        }
    }

    $: if (yScroll > 50) {
        shadow = true;
    } else {
        shadow = false;
    }

    // open the keyboard friendly side menu
    const activateKeyboardMode = () => {
        if (!browser) return;
        if ($tabDetected && browser) {
            $keyboardMode = true;
            $menuDrawerOpen = true;
        }
    };

    // logic to hide the header on scroll up but also display it on scroll down
    // put this into a store so I can reference it on other sticky items in the main column
    let last_scroll: number = 0;
    $: {
        if (browser) {
            if (yScroll > last_scroll) {
                // downward scrolling
                if (browserWidth < 800 && scrollY > 60) $header_hiding = true;
            } else if (yScroll === 0) {
                $header_hiding = false;
            } else {
                // downward scrolling
                if (browserWidth < 800 && scrollY > 60) $header_hiding = false;
            }
            last_scroll = yScroll <= 0 ? 0 : yScroll;
        }
    }
</script>

<svelte:window bind:scrollY={yScroll} bind:innerWidth={browserWidth} />
<header
    style="
        --primary: {colors[$activeColor].color};
        --secondary: {colors[$activeColor].highlight};
    "
    bind:offsetHeight={$header_menu_height}
    class:shadow={mobileView || shadow}
    style:height="{$header_menu_height}px"
    style:padding-right="{$scrollDisabled ? $scrollBarWidth : 0}px"
    class:header_hiding={$header_hiding}
    class="noSelect"
>
    <div class="column">
        <a
            href={`/`}
            id="logo"
            on:focus={() => ($focusDetected = true)}
            on:focusout={activateKeyboardMode}
            on:click={() => ($activeColor = randomIntFromInterval(0, 4))}
            on:click={() => ($activeSection = "home")}
        >
            <Logo />
        </a>
        {#if browserWidth > 1024}
            <Desktop />
        {:else}
            <MobileTrigger />
        {/if}
    </div>
</header>

<style>
header {
  line-height: 1;
  position: fixed;
  top: 0;
  z-index: 3;
  width: 100%;
  z-index: 6;
  background: white;
  min-height: 50px;
  display: flex;
  flex-flow: row;
  align-items: center;
  transition: box-shadow 500ms ease-out;
  height: 100px;
  transition: transform 100ms ease-out;
}
@media (max-width: 1024px) {
  header {
    height: 60px !important;
  }
}
header.header_hiding {
  transform: translateY(-100%);
}
header.shadow {
  box-shadow: 0px 0px 5.3px rgba(100, 122, 139, 0.07), 0px 0px 17.9px rgba(100, 122, 139, 0.044), 0px 0px 80px rgba(215, 237, 255, 0.5);
}
header #logo {
  display: flex;
  align-items: center;
  font-family: Bitter;
  font-weight: bold;
  text-decoration: none;
  font-size: 1.6rem;
  color: var(--title);
}
header .column {
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding: 0 40px;
  max-width: var(--max);
  min-height: 50px;
}

@media (max-width: 1024px) {
  header .column {
    padding: 0 2rem;
  }
  header #logo {
    font-size: 1.4rem;
  }
}
@media (max-width: 768px) {
  header .column {
    padding: 0 1rem;
  }
}
@media (max-width: 500px) {
  header .column {
    padding: 0 0.5rem;
  }
}
</style>
